import template from './profile.html';
import controller from './profile.controller';

let profileComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default profileComponent;



// WEBPACK FOOTER //
// ./client/pages/profile/profile.component.js